<full-calendar
   #permissionCalendar
   [options]="calendarOptions">
</full-calendar>